// extracted by mini-css-extract-plugin
export default {"wrap":"MicrositeSourceBreakdown_wrap__lG4us","empty":"MicrositeSourceBreakdown_empty__0qs85"};